import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import * as XLSX from 'xlsx';

import { environment } from '../../../../environments/environment';
import { Constants, LocationsService, Session } from '../../../core';

@Injectable({
  providedIn: 'root'
})
export class DataTableService {
  private session: Session;
  constructor(private router: Router, private route: ActivatedRoute, public locationsService: LocationsService) { }
  /**
   * TODO: Función que retorna la lista
   * para el control selected del filtro
   */
  typeFilter(type): Observable<any> {
    switch (type) {
      case 'entity':
      case 'entityClasic':
      case 'entityRoute':
      case 'dispatchRoute':
      case 'dispatchCapacity':
        return of(Constants.Entity.ENTITY_TYPES);
      case 'dispatchZone':
      case 'shipping':
        return this.locationsService._filterDepartment();
      default:
      return of([]);
    }
  }

  viewRecord(
    $event: any,
    data?: any,
    type?: any,
    typeModule?: string,
    typeEdition?: string,
    selection?: any,
    ids?: any,
    link?: string
  ) {
    if (!$event || ($event.target.className && $event.target.className.match(/recordColumn|mat-mdc-cell/))) {
      switch (typeModule) {
        case 'entity':
          this.router.navigate([!data ? link + '/mantenimiento/crear' : link + '/mantenimiento/' + data.entityCode]);
          break;
        case 'entityClasic':
          this.router.navigate([link, !data ? 'crear' : data.entityCode]);
          break;
        case 'dispatchType':
          this.router.navigate([link, !data ? 'crear' : data.id]);
          break;
        case 'dispatchZone':
          if (typeEdition === 'zone' || !data) {
            this.router.navigate([link, !data ? 'crear' : data.zoneId]);
          } else {
            this.router.navigate([
              '/configuracion/zonas/',
              data.zoneTypeDescription
                .split(' ')
                .join('-')
                .toLowerCase(),
              'editar',
              data.id
            ]);
          }
          this.session = JSON.parse(localStorage.getItem(environment.sessionAuth));
          delete this.session.entityZone;
          this.setStorage(this.session);
          break;
        case 'entityRoute':
        case 'dispatchRoute':
        case 'securityStock':
          if (!data) {
            this.router.navigate([link, 'crear']);
          } else {
            this.router.navigate([link, 'configurar', data.id]);
          }
          break;
        case 'securityStockCes':
          if (!data) {
            this.router.navigate([link, 'crear']);
          }
          break;
        case 'securityStockCesSPSA':
          if (!data) {
            this.router.navigate([link, 'crear']);
          }
          break;
        case 'shipping':
        case 'storePickupShipping':
          if (!data) {
            this.router.navigate([link, 'crear', ids ? ids : '']);
          } else if (type === 'configuration') {
            this.router.navigate([
              link,
              'editar',
              data.id + '|' + data.description + '|' + data.dispatchTypeId + '|' + ids.split('|')[0]
            ]);
          } else if (type === 'RTconfiguration') {
            this.router.navigate([link, 'editar',  data.id + '|' + data.description + '|' + data.dispatchTypeId + '|' + ids ]);
          }
          break;
        case 'inStorePicking':
          this.router.navigate([link, !data ? 'crear' : data.orderId]);
          break;
        case 'saleNote':
          this.router.navigate([link + '/' +  (!data ? 'detalle' : data.orderInfo.orderNumber + '/company/' + data.orderInfo.companyCode)]);
          break;
        case 'trip':
          this.router.navigate([link + '/' + data.id + '/detalle-viaje']);
          break;
        case 'saleNoteReport':
          localStorage.setItem('saleNoteStatusReport-' + data.saleNoteId, JSON.stringify(data));
          this.router.navigate([link, !data ? 'detalle' : data.saleNoteId]);
          break;
        case 'userSetting':
          if (data) {
            localStorage.setItem('user-setting-' + data.username, JSON.stringify(data));
          }
          this.router.navigate([link + '/editar', !data ? 'mantenimiento' : data.username]);
          break;
        case 'userExternalSetting':
            if (data) {
              localStorage.setItem('user-setting-' + data.userId, JSON.stringify(data));
            }
            this.router.navigate([link + '/editar', !data ? 'mantenimiento' : data.userId]);
            break;
        case 'exceptionalRate':
          if (type === 'RTexceptionalRate') {
            this.router.navigate(['/configuracion/flete/modificar-tarifa/' + data.idFreight + '/' + data.identifier + '/' + ids.split('|')[0] + '/' + ids.split('|')[1] + '/' + ids.split('|')[2] + '/' + 'RT'], { relativeTo: this.route });
          }
          this.router.navigate(['/configuracion/flete/modificar-tarifa/' + data.idFreight + '/' + data.identifier + '/' + data.idZone], { relativeTo: this.route });
          break;
        case 'searchQuotationInfo':
          localStorage.setItem('cotizacion-' + data.quotationInfo.quotationNumber, JSON.stringify(data));
          this.router.navigate([link + '/cotizacion/', data.quotationInfo.quotationNumber]);
          break;
        case 'lotsList':
          if(!data){
            this.router.navigate([link, 'crear-lote']);
          }
          break;
        case 'capacityByEntity':
          if(link && data){
            if(data.capacityType === "PICKING_CAPACITY"){
              this.router.navigate([link + '/capacidad-picking/' + data.capacityNumber]);
            }
            if(data.capacityType === 'DISPATCH_CAPACITY'){
              this.router.navigate([link + '/capacidad-despacho/' + data.capacityNumber]);
            }
            if(data.capacityType === 'WITHDRAWAL_CAPACITY'){
              this.router.navigate([link + '/capacidad-retiro/' + data.capacityNumber]);
            }
          }
          break;
        case 'settingsDispach':
          if(data){
              this.router.navigate([link + '/create/' + data.id]);
          }
          break;
        case 'groupEntity':
          if (data) {
            const entityCodes: string[]  = data.entityCodes.split(',');
            this.router.navigate([link + '/agrupacion/' + entityCodes[0]]);
          } else {
            this.router.navigate([link, 'agrupacion']);
          }
          break;
        case 'deliveryWindowsSettings':
          this.router.navigate([link + '/editar', data.id]);
          break;
        case 'supportTickets':
          console.log(link + '/ticket-view', data.SystemId);
          this.router.navigate([link + '/ticket-view', data.SystemId]);
          break;
        case 'calculationRange':
          void this.router.navigate([link + '/editar', data.id]);
          break;
      }
    }
  }

  setStorage(value) {
    localStorage.setItem(environment.sessionAuth, JSON.stringify(value));
  }

  createLocalStorage(current, data) {
    this.session = JSON.parse(localStorage.getItem(environment.sessionAuth));
    if (this.session.table) {
      if (this.session.table[current]) {
        this.session.table[current].filter = data;
      } else {
        this.session.table[current] = { filter: data };
      }
    } else {
      this.session.table = { [current]: { filter: data } };
    }
    this.setStorage(this.session);
  }

  disbledSelect(value, type): boolean {
    switch (type) {
      case 'reazonRejection':
        if (value.processedAmount === 0) {
          return true;
        } else {
          if (value.processedAmount > 0) {
            return false;
          }
        }
        break;
      default:
        return false;
    }
    return false;
  }

  disabledMasterChecks(...arg): boolean {
    switch (arg[0]) {
      case 'inStoreLocation':
        return false;
      default:
        return false;
    }
  }

  // Función para deshabilitar la opción en dropdown
  disabledDropDown(type, value, selected: any[]): boolean {
    switch (type) {
      case 'trip':
        return (
          value === 'printGuide' && (selected[0].guiaState !== 'No impresa' || selected.length >= 2)
        );
      default:
        return false;
    }
  }

  exportData(dataExport: any[], aditional, exportTable, id?: any) {
    const dataExcel = dataExport.map(element => {
      const data = {};
      for (const column of exportTable.columns) {
        if (column.type !== 'url' && column.type !== 'editableColumns') {
          const value: any = column.value(element);
          let valueException = ""
          if (exportTable.exportFile.includes('reporte_modificaciones') && column.type === 'button' && column.title === 'Observaciones') {
            valueException = value.data[0];
            data[column.title] = valueException;
          } else {
            data[column.title] =
            typeof value === 'string' || typeof value === 'number'
              ? value
              : value
                ? value.value
                : null;
          }
        }
      }
      return data;
    });
    const name = aditional ? exportTable.exportFileAdditional : exportTable.exportFile;
    const i = name.indexOf('.xlsx');
    const nameWithId = id ? name.slice(0, i) + '_' + id + '.xlsx' : name;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataExcel);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '');
    XLSX
      .writeFile(wb, nameWithId);
  }

}
